function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import '../Charts.scss';
import * as d3 from 'd3';
import React, { Component } from 'react';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { BaseMixin } from '../Mixins/BaseMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CoordinateGridMixin } from '../Mixins/CoordinateGridMixin';
import { MarginsMixin } from '../Mixins/MarginsMixin';
import PropTypes from 'prop-types';
import { TileMixin } from '../Mixins/TileMixin';
import dc from 'dc';
export var BarChartGrouped = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BarChartGrouped, _Component);

  function BarChartGrouped(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_chart", null);

    _this.chartRef = React.createRef();
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    _this.createChart = _this.createChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = BarChartGrouped.prototype;

  _proto.createProp = function createProp(chart, prop, value) {
    if (value === void 0) {
      value = undefined;
    }

    var privProp = '_' + prop;
    chart[privProp] = value;

    chart[prop] = function (value) {
      if (value !== undefined) {
        chart[privProp] = value;
        return chart;
      } else {
        return chart[privProp];
      }
    };
  };

  _proto.createChart = function createChart(parent, chartGroup) {
    var _this$props = this.props,
        y = _this$props.y,
        customTitleFormat = _this$props.customTitleFormat;

    var _chart = dc.coordinateGridMixin(dc.marginMixin(dc.colorMixin(dc.baseMixin({}))));

    var _g = null;
    this.createProp(_chart, 'gap', 0.05);
    this.createProp(_chart, 'seriesGap', 0.1);
    this.createProp(_chart, 'renderLabels', true);
    this.createProp(_chart, 'renderTitles', true);
    this.createProp(_chart, 'label');
    this.createProp(_chart, 'barOrder');
    this.createProp(_chart, 'groupOrder');

    _chart.isLegendableHidden = function (d) {
      return false;
    };

    _chart.legendables = function () {
      return d3.set(_chart.data().map(function (d) {
        return d.key[1];
      })).values().map(function (d) {
        return {
          name: d,
          data: d,
          others: d,
          chart: _chart,
          color: _chart.colors()(d)
        };
      });
    };

    _chart.draw = function () {
      var _margins = _chart.margins();

      var _width = _chart.width() - (_margins.left + _margins.right);

      var _height = _chart.height() - (_margins.bottom + _margins.top);

      _chart.resetSvg();

      _g = _chart.svg().append('g').attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')'); // Extract and sort group

      var _group = _chart.data().slice(0).sort(function (a, b) {
        if (a.key[0] > b.key[0]) {
          return 1;
        } else if (b.key[0] > a.key[0]) {
          return -1;
        } else if (a.key[1] > b.key[1]) {
          return 1;
        } else if (b.key[1] > a.key[1]) {
          return -1;
        } else {
          return 0;
        }
      }); // Calculate min/max


      var values = d3.set(_group.map(function (d) {
        return d.value;
      })).values().map(function (d) {
        return +d;
      });
      var min = d3.min(values);
      var max = d3.max(values);
      values.length = 0; // List of groups = species here = value of the first column called group -> I show them on the X axis

      var groups = Array.from(new Set(_group.map(function (g) {
        return g.key[0];
      })));
      groups.sort(_chart.groupOrder()); // List of subgroups = header of the csv files = soil condition here

      var subgroups = Array.from(new Set(_group.map(function (g) {
        return g.key[1];
      })));
      subgroups.sort(_chart.barOrder()); // Create X axis

      _chart.x(d3.scaleBand().domain(groups).range([0, _width]).padding([_chart.seriesGap()]));

      _g.append('g').attr('transform', 'translate(0, ' + _height + ')').call(d3.axisBottom(_chart.x()).tickSize(5));

      if (_chart.xAxisLabel()) {
        _g.append('text').attr('class', 'x-axis-label').attr('transform', 'translate(' + _width / 2 + ', ' + (_chart.height() - 12) + ')').attr('text-anchor', 'middle').text(_chart.xAxisLabel());
      }

      min = min > 0 ? 0 : min * 1.1;
      max = max <= min ? min + 1 : max + (max - min) / 20;

      if (typeof y !== 'function') {
        // If no y-axis passed to diagram create one
        _chart.y(d3.scaleLinear().domain([min, max]).range([_height, 0]));
      } else {
        // If y axis passed, update the range
        if (_chart.y().domain()[0] !== y.domain()[0] || _chart.y().domain()[1] !== y.domain()[1]) {
          _chart.y(y);
        }

        _chart.y(_chart.y().range([_height, 0]));
      }

      if (_chart.yAxisLabel()) {
        _g.append('text').attr('class', 'y-axis-label').attr('transform', "translate(" + (-_margins.left + 12) + ", " + _height / 2 + ")rotate(-90)").attr('text-anchor', 'middle').text(_chart.yAxisLabel());
      }

      _g.append('g').call(d3.axisLeft(_chart.y())); // Another scale for subgroup position?


      var xSubgroup = d3.scaleBand().domain(subgroups).range([0, _chart.x().bandwidth()]).padding([_chart.gap()]); // Show the bars

      _g.append('g').selectAll('g') // Enter in data = loop group per group
      .data(groups).enter().append('g').attr('class', 'barGroup').attr('transform', function (d) {
        return 'translate(' + _chart.x()(d) + ',0)';
      }).selectAll('rect.bar').data(function (d) {
        return _group.filter(function (g) {
          return g.key[0] === d;
        });
      }).enter().append('rect').attr('class', 'bar').attr('x', function (d) {
        return xSubgroup(d.key[1]);
      }).attr('y', function (d) {
        return _chart.y()(d.value);
      }).attr('width', xSubgroup.bandwidth()).attr('height', function (d) {
        return _height - _chart.y()(d.value);
      }).attr('fill', function (d) {
        return _chart.colors()(d.key[1]);
      });

      if (_chart.renderTitle()) {
        _g.selectAll('rect.bar').append('svg:title').attr('class', 'barTitle').attr('fill', '#ffffff').attr('color', '#000000').text(function (d) {
          return customTitleFormat(d);
        });
      }

      if (_chart.renderLabel()) {
        _g.selectAll('g.barGroup').selectAll('text.barLabel').data(function (d) {
          return _group.filter(function (g) {
            return g.key[0] === d;
          });
        }).enter().append('text').attr('class', 'barLabel').attr('text-anchor', 'middle').attr('x', function (d) {
          return xSubgroup(d.key[1]) + xSubgroup.bandwidth() / 2;
        }).attr('y', function (d) {
          return _chart.y()(d.value) - 5;
        }).text(_chart.label());
      }
    };

    _chart._doRender = function () {
      _chart.draw();

      return _chart;
    };

    var _redrawTimeout;

    _chart._doRedraw = function () {
      if (_redrawTimeout) {
        clearTimeout(_redrawTimeout);
      }

      _redrawTimeout = setTimeout(function (d) {
        _chart.draw();
      }, 250);
      return _chart;
    };

    return _chart.anchor(parent, chartGroup);
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this$props2 = this.props,
        gap = _this$props2.gap,
        renderLabel = _this$props2.renderLabel,
        renderTitle = _this$props2.renderTitle,
        seriesGap = _this$props2.seriesGap,
        label = _this$props2.label,
        groupOrder = _this$props2.groupOrder,
        barOrder = _this$props2.barOrder,
        legend = _this$props2.legend,
        y = _this$props2.y,
        x = _this$props2.x;
    this._chart = this.createChart(this.chartRef.current); // Set mixin properties

    BaseMixin(this._chart, this.props);
    ColorMixin(this._chart, this.props);
    MarginsMixin(this._chart, this.props);
    CoordinateGridMixin(this._chart, this.props);
    TileMixin(this._chart, this.props); // Set custom properties

    this._chart.barOrder(barOrder).groupOrder(groupOrder).gap(gap).seriesGap(seriesGap).renderLabel(renderLabel).renderTitle(renderTitle).label(label);

    if (legend === 'top' || legend === 'bottom') {
      var m = this._chart.margins();

      var c = this._chart;
      var l = dc.legend().itemHeight(15).gap(10).horizontal(true).autoItemWidth(true).legendWidth(c.width() - (m.left + m.right)).x(m.left);

      if (legend === 'top') {
        m.top += 25;
        l.y(m.top - 25);
      } else if (legend === 'bottom') {
        m.bottom += 40;
        l.y(c.height() - m.bottom + 25);
      }

      this._chart.legend(l);
    } // Render chart


    this._chart.render();
  };

  _proto.getChart = function getChart() {
    return this._chart;
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: "avi-chart chart bar-chart-grouped",
      ref: this.chartRef
    }));
  };

  return BarChartGrouped;
}(Component);

_defineProperty(BarChartGrouped, "defaultProps", {
  width: 600,
  height: 400,
  renderLabel: true,
  renderTitle: true,
  gap: 0.05,
  seriesGap: 0.1,
  label: function label(d) {
    return d.value;
  },
  useViewBoxResizing: true,
  groupOrder: function groupOrder(a, b) {
    return a - b;
  },
  barOrder: function barOrder(a, b) {
    return a - b;
  },
  margins: [10, 10, 12, 55],
  legend: null,
  customTitleFormat: function customTitleFormat(d) {
    return d.key[0] + "/" + d.key[1] + ": " + d.value;
  }
});

BarChartGrouped.propTypes = process.env.NODE_ENV !== "production" ? {
  /** A Crossfilter dimension made that returns an array key, e.g. crossfilter.dimension(d=>[d.key, d.key2]).
   * The first element in the array will be used as the main group (will be shown on the X-axis),
   * the second value will be used as a subgroup to render one bar for each unique sub-group value within the group. */
  dimension: PropTypes.object.isRequired,

  /** A Crossfilter group made on the same dimension */
  group: PropTypes.object.isRequired,

  /** Either an array of colors or a function that accepts a value and returns a color */
  colors: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),

  /** Title to render on the chart */
  chartTitle: PropTypes.string,

  /** Width of diagram in pixels, used to determine aspect ratio together with height*/
  width: PropTypes.number,

  /** Height of diagram in pixels, used to determine aspect ration together with width */
  height: PropTypes.number,

  /** Gap between bars in a group */
  gap: PropTypes.number,

  /** Gap between groups of bars */
  seriesGap: PropTypes.number,

  /** Render labels on top of each bar */
  renderLabel: PropTypes.bool,

  /** Render tool tip titles on mouseover of bars */
  renderTitle: PropTypes.bool,

  /** Function to use for labeling */
  label: PropTypes.func,

  /** Whether to resize the chart dynamically */
  useViewBoxResizing: PropTypes.bool,

  /** Array determining margins, [top, right, bottom, left] */
  margins: PropTypes.array,

  /** Function to sort groups */
  groupOrder: PropTypes.func,

  /** Function to sort bars in group */
  barOrder: PropTypes.func,

  /** Whether to include legend and where to place it */
  legend: PropTypes.oneOf([null, 'top', 'bottom']),

  /** Label for X-axis */
  xAxisLabel: PropTypes.string,

  /** Label for Y-axis */
  yAxisLabel: PropTypes.string,

  /** An Y-axis definition */
  y: PropTypes.func,

  /** An X-axis definition */
  x: PropTypes.func,

  /** Function to set custom tool tip on mouseover of bars */
  customTitleFormat: PropTypes.func
} : {};
export default BarChartGrouped;